import { render, staticRenderFns } from "./ChooseNewPassword.vue?vue&type=template&id=55114615&scoped=true&"
import script from "./ChooseNewPassword.vue?vue&type=script&lang=js&"
export * from "./ChooseNewPassword.vue?vue&type=script&lang=js&"
import style0 from "./ChooseNewPassword.vue?vue&type=style&index=0&id=55114615&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55114615",
  null
  
)

export default component.exports